import { collection, getDocs, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../firebaseconfig';

// Fetch all stock categories from database
export const fetchStockCategories = async () => {
  try {
    const categoriesRef = collection(db, 'stock_categories');
    const snapshot = await getDocs(categoriesRef);
    const categories = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    // Filter to only return active categories (or all if isActive is not set)
    return categories.filter(cat => cat.isActive !== false);
  } catch (error) {
    console.error('Error fetching stock categories:', error);
    throw error;
  }
};

// Create a new stock category
export const createStockCategory = async (categoryData) => {
  try {
    const categoriesRef = collection(db, 'stock_categories');
    const docRef = await addDoc(categoriesRef, {
      ...categoryData,
      createdAt: Timestamp.now(),
      isActive: true
    });
    return { id: docRef.id, ...categoryData };
  } catch (error) {
    console.error('Error creating stock category:', error);
    throw error;
  }
};

// Initialize default stock categories
export const initializeDefaultStockCategories = async () => {
  try {
    const existing = await fetchStockCategories();
    if (existing.length > 0) {
      return existing;
    }
    
    const categoriesRef = collection(db, 'stock_categories');
    const defaultCategories = [
      { name: 'Food & Beverages', description: 'Food items and beverages', color: '#FF6B6B', icon: 'FaUtensils' },
      { name: 'Office Supplies', description: 'Office equipment and supplies', color: '#4ECDC4', icon: 'FaToolbox' },
      { name: 'Cleaning Supplies', description: 'Cleaning and hygiene products', color: '#45B7D1', icon: 'FaHandHoldingWater' },
      { name: 'Medical Supplies', description: 'Medical and health products', color: '#FFA07A', icon: 'FaHandHoldingHeart' },
      { name: 'Electronics', description: 'Electronic devices and accessories', color: '#98D8C8', icon: 'FaLightbulb' },
      { name: 'Raw Materials', description: 'Raw materials for production', color: '#F7DC6F', icon: 'FaToolbox' },
      { name: 'Packaging', description: 'Packaging materials', color: '#BB8FCE', icon: 'FaShoppingBasket' },
      { name: 'Other', description: 'Other stock items', color: '#95A5A6', icon: 'FaQuestion' }
    ];
    
    const created = [];
    const timestamp = Timestamp.now();
    for (const category of defaultCategories) {
      const docRef = await addDoc(categoriesRef, {
        ...category,
        createdAt: timestamp,
        isActive: true
      });
      created.push({ id: docRef.id, ...category });
    }
    
    return created;
  } catch (error) {
    console.error('Error initializing default stock categories:', error);
    throw error;
  }
};

